const STORAGE_KEY = 'digipalzMissionRunRewardsV1'

export function shouldTrackMissionRunRewards() {
  if (typeof window === 'undefined') return false
  return window.location.pathname.includes('/game/mission/')
}

function readState() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return { coins: 0, exp: 0, levelUp: null }
    const parsed = JSON.parse(raw)
    return {
      coins: typeof parsed.coins === 'number' ? parsed.coins : 0,
      exp: typeof parsed.exp === 'number' ? parsed.exp : 0,
      levelUp: parsed.levelUp || null
    }
  } catch {
    return { coins: 0, exp: 0, levelUp: null }
  }
}

function writeState(data) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export function resetMissionRunRewards() {
  writeState({ coins: 0, exp: 0, levelUp: null })
}

export function addMissionRunRewardFromResult(result) {
  if (!result) return
  const coinsAwarded = result.coinsAwarded || 0
  const expAwarded = result.expAwarded || 0
  if (!coinsAwarded && !expAwarded && !result.didLevelUp) return

  const cur = readState()
  cur.coins += coinsAwarded
  cur.exp += expAwarded
  if (result.didLevelUp) {
    const next = result.levelAfter ?? 1
    cur.levelUp = {
      newLevel: next,
      levelLabel: result.levelLabel,
      prevLevel:
        typeof result.levelBefore === 'number'
          ? result.levelBefore
          : Math.max(1, next - 1)
    }
  }
  writeState(cur)
}

export function getMissionRunRewardsSummary() {
  return readState()
}

export function clearMissionRunRewards() {
  sessionStorage.removeItem(STORAGE_KEY)
}
